var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as moo from 'moo';
import { CoreTokenTypes } from './tokens';
import { getFinalRollConfig, } from './util/rollConfig';
var WHITE_SPACE = 'WHITE_SPACE';
function createTokenize(plugins, rollConfig) {
    var _a;
    var rules = (_a = {},
        _a[WHITE_SPACE] = /[ \t]+/,
        _a[CoreTokenTypes.Operator] = /\*|\/|\+|-/,
        _a[CoreTokenTypes.OpenParen] = '(',
        _a[CoreTokenTypes.CloseParen] = ')',
        _a);
    Object.values(plugins).forEach(function (plugin) {
        rules[plugin.typeConstant] = plugin.regex;
    });
    var lexer = moo.compile(rules);
    var faultTolerantLexer = moo.compile(__assign(__assign({}, rules), { error: moo.error }));
    function tokenize(notation, configOverrides) {
        var finalConfig = getFinalRollConfig(rollConfig, configOverrides);
        lexer.reset(notation);
        return Array.from(lexer)
            .filter(function (token) { return token.type !== WHITE_SPACE; })
            .map(function (token) { return processToken(token, finalConfig); });
    }
    function tokenizeFaultTolerant(notation, configOverrides) {
        var finalConfig = getFinalRollConfig(rollConfig, configOverrides);
        faultTolerantLexer.reset(notation);
        var allTokens = Array.from(faultTolerantLexer);
        var tokens = allTokens
            .filter(function (token) { return token.type && ![WHITE_SPACE, 'error'].includes(token.type); })
            .map(function (token) { return processToken(token, finalConfig); });
        var lastToken = allTokens[allTokens.length - 1];
        var error = (lastToken === null || lastToken === void 0 ? void 0 : lastToken.type) === 'error'
            ? {
                type: 'error',
                position: lastToken.col - 1,
                content: lastToken.text,
            }
            : null;
        return { tokens: tokens, error: error };
    }
    /**
     * Take a moo token and turn it into a dice-notation token.
     * @param token the moo token
     */
    function processToken(token, config) {
        if (!token.type)
            throw new Error('Unrecognized token');
        switch (token.type) {
            case CoreTokenTypes.Operator:
                return {
                    type: CoreTokenTypes.Operator,
                    position: token.col - 1,
                    content: token.value,
                    operator: token.value,
                };
            case CoreTokenTypes.OpenParen:
                return {
                    type: CoreTokenTypes.OpenParen,
                    position: token.col - 1,
                    content: token.value,
                };
            case CoreTokenTypes.CloseParen:
                return {
                    type: CoreTokenTypes.CloseParen,
                    position: token.col - 1,
                    content: token.value,
                };
            default:
                var rule = plugins[token.type];
                if (!rule)
                    throw new Error("Unrecognized token of type " + token.type);
                return {
                    type: CoreTokenTypes.DiceRoll,
                    content: token.value,
                    position: token.col - 1,
                    detailType: rule.typeConstant,
                    detail: rule.tokenize(token.value, config),
                };
        }
    }
    return { tokenize: tokenize, tokenizeFaultTolerant: tokenizeFaultTolerant };
}
export default createTokenize;
